<template>
  <div v-if="markers.length">
    <gmap-map
      class="infoBorder gmapMobile"
      :center="{
        lat: markers[0].latitude,
        lng: markers[0].longitude,
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="map">
      <gmap-marker
        v-for="(m, index) in markers"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude,
        }"
        :icon="m.icon"
        @click="afficheFace(m)">
      </gmap-marker>
      <gmap-marker
        v-if="markerFaceLc.lat"
        :position="{
          lat: markerFaceLc.lat,
          lng: markerFaceLc.lng,
        }"
        :icon="markerFaceLc.icon">
      </gmap-marker>
    </gmap-map>
    <app-detail-opportunites :detailFaceLc="detailFaceLc" v-if="show"/>
  </div>
</template>

<script>
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';
import detailOpportunites from './detailOpportunites';

export default {
  name: 'cartePanneauxLc',
  props: ['markers', 'markerFaceLc'],
  components: {
    appDetailOpportunites: detailOpportunites,
  },
  data() {
    return {
      moyLat: 0,
      moyLng: 0,
      centreCarte: {},
      detailFaceLc: {},
      show: false,
      bg: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
      isLoadOnce: false,
    };
  },
  methods: {
    afficheFace(m) {
      this.detailFaceLc = m;
      this.show = true;
    },
    async levelZoom() {
      if (this.markers.length && !this.isLoadOnce) {
        const map = await this.$refs.map.$mapPromise;
        const bounds = new google.maps.LatLngBounds();
        filterLatLng(this.markers);
        this.markers.forEach(m => {
          if (m.latitude !== 0 && m.longitude !== 0
          && m.latitude !== null && m.longitude !== null) {
            bounds.extend({ lat: m.latitude, lng: m.longitude });
          }
        });
        if (this.markerFaceLc !== undefined && this.markerFaceLc.lat !== undefined) {
          bounds.extend({ lat: this.markerFaceLc.lat, lng: this.markerFaceLc.lng });
        }
        map.fitBounds(bounds);
        this.isLoadOnce = true;
      }
    },
  },
  async mounted() {
    const map = await this.$refs.map.$mapPromise;
    const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
      name: MAP_TYPE_NAME,
    });
    map.mapTypes.set('styled_map', styleMap);
    this.levelZoom();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/panneauxLc/cartePanneauxLc.vue